import { useCallback, useRef } from 'react'
import { FileAddOutlined } from '@ant-design/icons'
import { Button, Group, Text } from '@mantine/core'
import { Dropzone, IMAGE_MIME_TYPE, PDF_MIME_TYPE, MS_WORD_MIME_TYPE, MIME_TYPES} from '@mantine/dropzone'
import { FileRejection } from 'react-dropzone'
import { notification } from 'antd'
import { useIntl } from 'react-intl'

const MAX_FILE_SIZE = 20971520 //  20 MB, check value in messages on change!

type FileUploadButtonProps = {
  isLoading: boolean;
  onUploadFiles: (files: Array<File>) => void;
}

export const dropzoneChildren = () => (
  <Group position='center' spacing='xl' style={{ minHeight: 220, pointerEvents: 'none' }}>
    <div>
      <Text size='xl' inline>
        Drag images here or click to select files
      </Text>
      <Text size='sm' color='dimmed' inline mt={7}>
        Attach as many files as you like, each file should not exceed 5mb
      </Text>
    </div>
  </Group>
)

export function FileUploadButton({ isLoading, onUploadFiles }: FileUploadButtonProps) {
  const openRef = useRef<() => void|undefined>(null)
  const intl = useIntl()

  const onChange = useCallback((files: Array<File>) => {
    onUploadFiles(files)
  }, [onUploadFiles])

  const onReject = useCallback((rejections: Array<FileRejection>) => {
    rejections.map(rejection =>
      notification.error({
        message: `${intl.messages['externalSourceProposal.proposalFiles.errorSize']}: ${rejection.file.name}:`,
        duration: 5,
      }),
    )
  }, [intl])

  return (
    <>
      <div hidden>
        <Dropzone
          multiple
          openRef={openRef}
          accept={[
            ...IMAGE_MIME_TYPE,
            MIME_TYPES.pdf,
            MIME_TYPES.doc,
            MIME_TYPES.docx,
            MIME_TYPES.xls,
            MIME_TYPES.xlsx,
          ]}
          maxSize={MAX_FILE_SIZE}
          onDrop={onChange}
          onReject={onReject}
          loading={isLoading}
          style={{}}
        >
          {() => dropzoneChildren()}
        </Dropzone>
      </div>

      <Button
        onClick={() => openRef.current?.()}
        loading={isLoading}
        rightIcon={<FileAddOutlined size={18}/>}
      >
        {intl.messages['externalSourceProposal.proposalFiles.uploadFiles'] as string}
      </Button>
    </>
  )
}